<div class="container">
    <div class="header-container">
        <span class="h3-regular header-title">{{ currPage.id }}</span>
    </div>
    <div class="body-container" *ngIf="maptile">
        <!-- <div> -->
        <span class="span-maptile body-2">{{'mapTile.enable_google_map_service' | stringLiterals}}</span>
        <label class="body-3">{{'mapTile.this_feature_will_leverage_google_map_api' | stringLiterals}}</label>
        <!-- </div> -->
        <div class="switch-maptile inner-block-top">
            <kendo-switch [checked]="maptile.enable" onLabel="Yes" offLabel="No"
                (valueChange)="changeMapTileEnableStatus($event)"></kendo-switch>
        </div>
        <div class="pulling-content" *ngIf="maptile.enable">
            <span class="body-2">
                {{'mapTile.pulling_coordinates_for_existing_contacts_entities_and_events' | stringLiterals}}
            </span>
            <span class="body-3">
                {{'mapTile.only_the_ones_with_coordinates_data_can_be_marked_on_map_tile' | stringLiterals}}
            </span>
            <button class="start-button" tam-button tamType="primary" tamSize="normal"
                [tamLoading]="isProgressing&&maptile.enable" [disabled]="isProgressing||!maptile.enable"
                [ngClass]="{'disable-button':!maptile.enable||isProgressing}"
                (click)="clickStartPulling()">{{'mapTile.start' | stringLiterals}}</button>
            <span *ngIf="isProgressing" class="pulling-tip">{{'mapTile.pulling_coordinates_is_in_progress' |
                stringLiterals}} </span>
        </div>
    </div>
</div>